import { Grid } from '@material-ui/core';
import { Link, useHistory } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import logoCadastroUnico from '../../assets/img/logo-cadunico-web.png';
import { authLogout, selectGovBr } from '../../auth/authSlice';
import {
  mostrarComprovante,
  mostrarConsultaCompleta,
  mostrarConsultaCpf,
  mostrarConsultaEscolaridade,
  mostrarConsultaPendencias,
  mostrarConsultaRenda,
  mostrarConsultaSimples,
  mostrarExclusaoCadastralTutorial,
  mostrarMeusBeneficios,
  mostrarPostosAtendimento,
  mostrarProgramasSociais,
  mostrarTermoDeUso,
  mostrarValidacaoComprovante
} from '../../features/Home/Home';
import { selectLogado } from '../../features/IdentificacaoPositiva/identificacaoPositivaSlice';
import {
  selectPerfilCompleto,
  selectPermiteRemoverFamiliaCadUnico,
  selectSelecionouSolicitacaoCadastramento,
  selectSituacaoCadastroFamilia,
} from '../../features/Perfil/perfilSlice';
import { SituacaoCadastroFamiliaUsuario } from '../../model/SituacaoCadastroFamiliaUsuario';
import styles from './Footer.module.css';
import { iniciarSolicitacaoCadastramento, verificarSeFamiliaEstahCadastrada } from '../../common/solicitacaoUtils';

const Footer: React.FC = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();

  const perfil = useAppSelector(selectPerfilCompleto);
  const govBrLogado = useAppSelector(selectGovBr).logado;
  const situacaoCadastroFamilia = useAppSelector(selectSituacaoCadastroFamilia);
  const isAuthenticatedIdPositiva = useAppSelector(selectLogado);
  const permiteRemoverFamiliaCadUnico = useAppSelector(selectPermiteRemoverFamiliaCadUnico);
  const selecionouSolicitacaoCadastramento = useAppSelector(selectSelecionouSolicitacaoCadastramento);

  const PERMITE_PRE_CADASTRO_USUARIO = situacaoCadastroFamilia?.situacaoCadastroFamiliaUsuario !== SituacaoCadastroFamiliaUsuario.USUARIO_COM_FAMILIA_CADASTRADA;

  const isLogadoGovBr = () => {
    return (govBrLogado && situacaoCadastroFamilia);
  };
  const isLogadoIdPositiva = () => {
    return !!isAuthenticatedIdPositiva;
  };
  const isLogado = () => {
    return isLogadoGovBr() || isLogadoIdPositiva();
  };

  const logout = () => {
    dispatch(authLogout({ history }));
  };

  const aptoPreCadastro = () => {
    return (
      situacaoCadastroFamilia?.situacaoCadastroFamiliaUsuario ===
      SituacaoCadastroFamiliaUsuario.USUARIO_APTO_A_COMECAR_O_PRE_CADASTRO ||
      situacaoCadastroFamilia?.situacaoCadastroFamiliaUsuario ===
      SituacaoCadastroFamiliaUsuario.USUARIO_COM_PRAZO_CADASTRO_DECORRIDO ||
      situacaoCadastroFamilia?.situacaoCadastroFamiliaUsuario ===
      SituacaoCadastroFamiliaUsuario.USUARIO_COM_FAMILIA_COM_PRE_CADASTRO_INICIADO ||
      situacaoCadastroFamilia?.situacaoCadastroFamiliaUsuario ===
      SituacaoCadastroFamiliaUsuario.USUARIO_COM_FAMILIA_COM_PRE_CADASTRO_FINALIZADO_NAO_ENVIADO ||
      situacaoCadastroFamilia?.situacaoCadastroFamiliaUsuario ===
      SituacaoCadastroFamiliaUsuario.USUARIO_COM_FAMILIA_COM_PRE_CADASTRO_FINALIZADO_ENVIADO ||
      situacaoCadastroFamilia?.situacaoCadastroFamiliaUsuario ===
      SituacaoCadastroFamiliaUsuario.USUARIO_COM_FAMILIA_COM_PRE_CADASTRO_FINALIZADO_ENVIADO_REJEITADO
    );
  };

  return (
    <>
      <div className={styles.containerWeb}>
        <div className={styles.contentWeb}>
          <div className={styles.footerMenu}>
            <Grid container spacing={3}>
              <Grid item xs={6} md={3}>
                <div className={styles.footerMenuTitle}>Cadastro</div>

                {!isLogado() && (
                  <>
                    <div
                      className={`${styles.footerMenuItem} ${aptoPreCadastro() ? styles.disabled : ''}`}
                      onClick={() => mostrarConsultaCpf(history)}
                    >
                      Consulta por CPF
                    </div>
                    {/* <div
                      className={`${styles.footerMenuItem} ${aptoPreCadastro() ? styles.disabled : ''}`}
                      onClick={() => (aptoPreCadastro() ? null : mostrarIdentificacaoPositiva(history))}
                    >
                      Consulta simples
                    </div> */}
                  </>
                )}

                {isLogadoGovBr() && (
                  <>
                    <div
                      className={`${styles.footerMenuItem} ${selecionouSolicitacaoCadastramento || (PERMITE_PRE_CADASTRO_USUARIO && !perfil?.temRL)  ? styles.disabled : ''}`}
                      onClick={() => mostrarConsultaPendencias(history)}
                    >
                      Pendências do cadastro
                    </div>
                    <div
                      className={`${styles.footerMenuItem} ${selecionouSolicitacaoCadastramento || (PERMITE_PRE_CADASTRO_USUARIO && !perfil?.temRL) ? styles.disabled : ''}`}
                      onClick={() => mostrarConsultaCompleta(history)}
                    >
                      Consulta ao formulário
                    </div>
                   {/* <div
                      className={`${styles.footerMenuItem} ${!selecionouSolicitacaoCadastramento || !aptoPreCadastro() || verificarSeFamiliaEstahCadastrada(situacaoCadastroFamilia, perfil, selecionouSolicitacaoCadastramento) ? styles.disabled : ''}`}
                      onClick={() => iniciarSolicitacaoCadastramento(history, situacaoCadastroFamilia)}
                    >
                      Solicitação de cadastramento
                    </div>*/}
                    {/* <div
                      className={`${styles.footerMenuItem} ${styles.disabled}`}
                      // className={`${styles.footerMenuItem} ${aptoPreCadastro() ? styles.disabled : ''}`}
                      // onClick={() =>
                      //   aptoPreCadastro()
                      //     ? null
                      //     : mostrarAtualizacaoCadastralPorConfirmacao(history)
                      // }
                    >
                      Atualização cadastral por confirmação
                    </div> */}
                    {permiteRemoverFamiliaCadUnico && (
                      <div
                        className={`${styles.footerMenuItem}`}
                        onClick={() => mostrarExclusaoCadastralTutorial(history, false)}
                      >
                        Cancele o seu cadastro
                      </div>
                    )}
                  </>
                )}

                {isLogadoIdPositiva() && (
                  <div
                    className={`${styles.footerMenuItem} ${selecionouSolicitacaoCadastramento || (PERMITE_PRE_CADASTRO_USUARIO && !perfil?.temRL) ? styles.disabled : ''}`}
                    onClick={() => (mostrarConsultaSimples(history))}
                  >
                    Dados resumidos da família
                  </div>
                )}

                {(isLogadoGovBr() || isLogadoIdPositiva()) && (
                  <div
                    className={`${styles.footerMenuItem} ${selecionouSolicitacaoCadastramento || (PERMITE_PRE_CADASTRO_USUARIO && !perfil?.temRL) ? styles.disabled : ''}`}
                    onClick={() => mostrarComprovante(history)}
                  >
                    Comprovante de cadastro
                  </div>
                )}

                <br />
                <Link to="/como-cadastrar">
                  <div className={styles.footerMenuItem}>Como se cadastrar</div>
                </Link>
                <Link to="/como-atualizar">
                  <div className={styles.footerMenuItem}>Como atualizar seu cadastro</div>
                </Link>
               {/**  <Link to="/exclusaoCadastral/tutorial">
                  <div className={styles.footerMenuItem}
                    onClick={() => localStorage.setItem('enviar-para-home', 'true')}>Como cancelar o seu cadastro</div>
                </Link>*/}
                <Link
                  to={{
                    pathname: '/consultaRenda/tutorial',
                    state: { readOnly: true }
                  }}
                >
                  <div className={styles.footerMenuItem}>Como consultar renda CNIS</div>
                </Link>
                <div className={styles.footerMenuItem}>
                  <a
                    className={styles.textLink}
                    href="https://www.gov.br/mds/pt-br/acoes-e-programas/cadastro-unico"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Sobre o Cadastro Único
                  </a>
                </div>
                <div className={styles.footerMenuItem}>
                  <a
                    className={styles.textLink}
                    href="https://www.gov.br/mds/pt-br/acoes-e-programas/cadastro-unico/perguntas-frequentes-cadastro-unico"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Perguntas frequentes
                  </a>
                </div>
              </Grid>
              <Grid item xs={6} md={3}>
                <div className={styles.footerMenuTitle}>Opções</div>
                {isLogado() && (
                  <>
                    <div
                      className={`${styles.footerMenuItem} ${selecionouSolicitacaoCadastramento || (PERMITE_PRE_CADASTRO_USUARIO && !perfil?.temRL) ? styles.disabled : ''}`}
                      onClick={() => mostrarMeusBeneficios(history)}
                    >
                      Meus benefícios
                    </div>
                    <div
                       className={`${styles.footerMenuItem} ${selecionouSolicitacaoCadastramento || (PERMITE_PRE_CADASTRO_USUARIO && !perfil?.temRL) ? styles.disabled : ''}`}
                      onClick={() => mostrarConsultaRenda(history)}
                    >
                      Consulta de renda CNIS
                    </div>
                    <div
                      className={`${styles.footerMenuItem} ${selecionouSolicitacaoCadastramento || (PERMITE_PRE_CADASTRO_USUARIO && !perfil?.temRL) ? styles.disabled : ''}`}
                      onClick={() => mostrarConsultaEscolaridade(history)}
                    >
                      Consulta de escolaridade
                    </div>
                  </>
                )}
                <div
                  className={styles.footerMenuItem}
                  onClick={() => mostrarPostosAtendimento(history)}
                >
                  Postos de atendimento
                </div>
                <div
                  className={styles.footerMenuItem}
                  onClick={() => mostrarProgramasSociais(history)}
                >
                  Programas sociais
                </div>
                <div
                  className={styles.footerMenuItem}
                  onClick={() => mostrarValidacaoComprovante(history)}
                >
                  Validar comprovante
                </div>
                <div className={styles.footerMenuItem} onClick={() => mostrarTermoDeUso(history)}>
                  Termos de uso
                </div>
              </Grid>
              {situacaoCadastroFamilia && (
                <Grid item xs={6} md={3}>
                  <div className={styles.footerMenuTitle}>Perfil</div>
                  {perfil && (
                    <Link to="/perfil">
                      <div className={styles.footerMenuItem}>Ver perfil</div>
                    </Link>
                  )}
                  <div className={styles.footerMenuItem} onClick={() => logout()}>
                    Sair
                  </div>
                </Grid>
              )}
            </Grid>
          </div>
          <hr />
          <div className={styles.footerLogos}>
            <img
              className={styles.logoCadastroUnico}
              src={logoCadastroUnico}
              alt="Logo Cadastro Único"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
